import {
  init,
  setUserId,
  identify,
  track,
  Identify,
} from '@amplitude/analytics-browser'
import { AnalyticsTrackParams } from './analytics-broker'

export interface AnalyticsIdentifyOnceParams {
  userId: string
  tenantId: string
}

export interface AnalyticsIdentifyParams {
  roles: string[]
}

export class AmplitudeService {
  identifyOnceParams?: AnalyticsIdentifyOnceParams

  constructor(apiKey: string, userId?: string) {
    init(apiKey, userId)
  }

  /**
   * Assigns a userId to past and future tracked events for this session. We
   * expose a separate method for this as we usually do not have the userId at
   * the time this service is initialised.
   */
  setUser(userId: string) {
    setUserId(userId)
  }

  /**
   * Captures immutable user properties that should never change over the
   * lifetime a given user.
   */
  async identifyOnce({ userId, tenantId }: AnalyticsIdentifyOnceParams) {
    if (this.identifyOnceParams) return

    this.identifyOnceParams = { userId, tenantId }
    const id = new Identify()

    id.setOnce('tenantId', tenantId)
    id.setOnce('userId', userId)

    return identify(id).promise
  }

  /**
   * Captures mutable user properties that may change over the lifetime of a
   * given user, such as their role or preferences.
   */
  async identify({ roles }: AnalyticsIdentifyParams) {
    const id = new Identify()

    id.set('roles', roles)

    return identify(id).promise
  }

  /**
   * Track a platform event with optional additional data
   */
  async track({ event, properties }: AnalyticsTrackParams) {
    return track(event, properties).promise
  }
}
